'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { StatusErrorCircleLinear, StatusCheckLinear } from '@s7/icons';

var InputIcon = function(param) {
    var state = param.state;
    switch(state){
        case "default":
            return null;
        case "success":
            return /*#__PURE__*/ jsx(StatusCheckLinear, {
                color: "primary.base"
            });
        case "error":
            return /*#__PURE__*/ jsx(StatusErrorCircleLinear, {
                color: "disruption.base"
            });
        default:
            return null;
    }
};
InputIcon.displayName = "InputIcon";

export { InputIcon };
